import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import QuestionField from './QuestionField'
import { Question } from 'types'

const propTypes = {
  questions: PropTypes.arrayOf(Question),
  isSubmitting: PropTypes.bool,
  onPhotoUploadAttempt: PropTypes.func,
  setCustomFormWideError: PropTypes.func,
  setFieldError: PropTypes.func,
}

const defaultProps = {
  questions: [],
  isSubmitting: false,
  onPhotoUploadAttempt: noop,
  setCustomFormWideError: noop,
  setFieldError: noop,
}

// Renders a flat list of API-driven custom questions. Used by the post-check-in
// questionnaire; the check-out form renders its fields individually so it can interleave
// its own root-cause slots.
function QuestionFields({
  questions,
  isSubmitting,
  onPhotoUploadAttempt,
  setCustomFormWideError,
  setFieldError,
}) {
  return questions.map((question) => (
    <QuestionField
      key={question.fieldName}
      question={question}
      isSubmitting={isSubmitting}
      onPhotoUploadAttempt={onPhotoUploadAttempt}
      setCustomFormWideError={setCustomFormWideError}
      setFieldError={setFieldError}
    />
  ))
}

QuestionFields.propTypes = propTypes
QuestionFields.defaultProps = defaultProps

export default QuestionFields
